var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVerTodosOsClubes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 83,
    viewBox: "0 0 114 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1032 -827)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1032 827)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1032 858)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1032 889)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1094 827)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1094 858)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1094 889)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1063 827)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1063 858)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1063 889)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1125 827)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1125 858)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 5,
    transform: "translate(1125 889)",
    fill: "#0c1151"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerTodosOsClubes);
export default __webpack_public_path__ + "static/media/icon-ver-todos-os-clubes.9a890d3b340dd14aa42ac75645889a89.svg";
export { ForwardRef as ReactComponent };